import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FieldEmailProps {
    email: string;
}

export default function FieldEmail({ email }: FieldEmailProps) {
    const { t } = useTranslation('profile');

    return (
        <TextField
            disabled
            label={ t('fields.email') }
            value={ email }
        />
    );
}
